import { render } from "./fullImageModal.vue?vue&type=template&id=892d50aa&scoped=true&ts=true"
import script from "./fullImageModal.vue?vue&type=script&lang=ts"
export * from "./fullImageModal.vue?vue&type=script&lang=ts"

import "./fullImageModal.vue?vue&type=style&index=0&id=892d50aa&scoped=true&lang=css"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-892d50aa"]])

export default __exports__